module.exports = __webpack_public_path__ + "static/media/comfort_bg_icon_svg.6dcc6bc3.svg";